import { api } from '../utils/axios';

// ========================
// HOST APIs
// ========================

/**
 * Fetch all hosts with optional search and pagination
 * @param {string} search - search by hostName or primaryPhone
 * @param {number} page - page number (default 1)
 * @param {number} limit - items per page (default 10)
 */
export const fetchHosts = async (search = '', page = 1, limit = 10) => {
  try {
    const response = await api.get('/hosts', {
      params: { search, page, limit },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching hosts:', error);
    throw error;
  }
};

/**
 * Fetch a single host by ID
 */
export const fetchHostById = async (id) => {
  try {
    const response = await api.get(`/hosts/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching host by ID:', error);
    throw error;
  }
};

/**
 * Create a new host
 */
export const createHost = async (formData) => {
  try {
    const response = await api.post('/hosts', formData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating host:', error);
    throw error;
  }
};

/**
 * Update a host
 */
export const updateHost = async (id, formData) => {
  try {
    const response = await api.patch(`/hosts/${id}`, formData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating host:', error);
    throw error;
  }
};

/**
 * Delete a host
 */
export const deleteHost = async (id) => {
  try {
    const response = await api.delete(`/hosts/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting host:', error);
    throw error;
  }
};

/**
 * Host login
 */
export const hostLogin = async (credentials) => {
  try {
    const response = await api.post('/hosts/login', credentials);
    return response.data.data;
  } catch (error) {
    console.error('Error logging in host:', error);
    throw error;
  }
};


export const createHostProfile = async (payload) => {
  try {
    const response = await api.post("/hosts/host-profiles", payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (err) {
    console.log("API ERROR:", err);
    throw err;
  }
};

export const updateHostProfile = async (hostId, payload) => {
  try {
    const response = await api.put(`/hosts/${hostId}/host-profiles`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (err) {
    console.log("API ERROR:", err);
    throw err;
  }
};

export const getHostProfileByHostId = async (hostId) => {
  try {
    console.log(`API: Fetching host profile for ID: ${hostId}`);
    const response = await api.get(`/hosts/${hostId}/getHostProfileByHostId`);
    console.log('API Response:', response);
return response.data.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const fetchDashboardStats = async () => {
  try {
    const response = await api.get('/hosts/dashboard/stats');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

export const getHostProfile= async (hostId) => {
  try {
    const response = await api.get(`/hosts/host-profiles/${hostId}`);  
    return response.data.data;
  } catch (error) {
    console.error('Error fetching host bookings:', error);
    throw error;
  } 
};

/**
 * Invite a new user
 */
export const inviteHostUser = async (payload) => {
  try {
    const response = await api.post('/hosts/invite', payload);
    return response.data.data;
  } catch (error) {
    console.error('Error inviting user:', error);
    throw error;
  }
};

/**
 * Remove an invited user
 */
export const removeHostUser = async (userId) => {
  try {
    const response = await api.delete(`/hosts/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing user:', error);
    throw error;
  }
};

/**
 * Set password for invited user
 */
export const setHostUserPassword = async (payload) => {
  try {
    const response = await api.post('/hosts/set-password', payload);
    return response.data;
  } catch (error) {
    console.error('Error setting password:', error);
    throw error;
  }
};

/**
 * Fetch roles for a host
 */
export const fetchHostRoles = async (hostId) => {
  try {
    const response = await api.get(`/hosts/roles/${hostId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

/**
 * Create a new role
 */
export const createHostRole = async (payload) => {
  try {
    const response = await api.post('/hosts/create-role', payload);
    return response.data.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};